import { render, staticRenderFns } from "./cham-more.vue?vue&type=template&id=0e7a170f&scoped=true"
import script from "./cham-more.vue?vue&type=script&lang=js"
export * from "./cham-more.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7a170f",
  null
  
)

export default component.exports